var nlnl = {
	"coupon-callout": {
	"coupon-code": "Code",
	"coupon-message-with-price": "Slechts {{ price }}",
	"coupon-expiry-message": "Vervalt {{ Date }}.",
	"code-at-checkout": "Voer code in op de betaalpagina. Kan niet gecombineerd worden met andere promocodes, promoties of kortingen.",
	"cancel-icon": "Annuleren",
	"info-icon": "Details bekijken",
	"check-icon": "Toegepast",
	"promo-code": "Promocode",
	"coupon-callout-popover": "Pop-up notitie waardebon"
}
};

export { nlnl as default };
//# sourceMappingURL=src-localization-texts-nl-nl.json.js.map
